import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { OutputHelper } from '../../interfaces/output-helper.interface';

@Injectable()
export class OutputHelpersService {
    private readonly selectedOutputHelpersOption$: Subject<OutputHelper> = new Subject<OutputHelper>();
    private readonly clearOutputHelperOptions$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    selectedOutputHelpersOptionChange(): Observable<OutputHelper> {
        return this.selectedOutputHelpersOption$.asObservable();
    }

    setSelectedOutputHelpersOption(option: OutputHelper): void {
        this.selectedOutputHelpersOption$.next(option);
    }

    clearOutputHelperOptions(): void {
        this.clearOutputHelperOptions$.next(true);
    }

    clearOutputHelperOptionsChange(): Observable<boolean> {
        return this.clearOutputHelperOptions$.asObservable();
    }
}
